import { useCallback, useRef, useState } from 'react';
import { searchDailyState } from 'services/unholsterDailyStateService';

const EMPTY_COUNTERS = {
  total: 0,
  sinGestion: 0,
  conGestion: 0,
  prioridadAlta: 0,
  conDocumento: 0,
};

export default function useUnholsterDailyState() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [counters, setCounters] = useState(EMPTY_COUNTERS);
  const [meta, setMeta] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);

  const abortControllerRef = useRef(null);

  const fetchDailyState = useCallback(async (query) => {
    if (abortControllerRef.current) abortControllerRef.current.abort();
    const controller = new AbortController();
    abortControllerRef.current = controller;

    setIsLoading(true);
    setError(null);

    try {
      const result = await searchDailyState(query, controller.signal);

      setData(result?.items ?? []);
      setTotal(result?.total ?? 0);
      setCounters(result?.contadores ?? EMPTY_COUNTERS);
      setMeta(result?.meta ?? null);
      setHasSearched(true);
    } catch (err) {
      if (err.name === 'AbortError' || err.name === 'CanceledError') return;

      setData([]);
      setTotal(0);
      setCounters(EMPTY_COUNTERS);
      setMeta(null);
      setError(err);
      setHasSearched(true);
    } finally {
      if (!controller.signal.aborted) setIsLoading(false);
    }
  }, []);

  // Parche local de una fila: lo usa la gestion para pintar antes del await y revertir si falla.
  const patchRow = useCallback((caseId, fecha, patch) => {
    setData((prev) =>
      prev.map((r) => (r.caseId === caseId && r.fecha === fecha ? { ...r, ...patch } : r))
    );
  }, []);

  return { data, total, counters, meta, isLoading, error, hasSearched, fetchDailyState, patchRow };
}
